"use client";

import { Grid as AfaGrid } from "@afa-shared/afa-components";
import React from "react";

/**
 * A wrapper around the AfaGrid component to be used in client components.
 * @param props - Props to be passed to the AfaGrid component.
 * @returns The AfaGrid component with the passed props.
 */
const Grid = (props: React.ComponentProps<typeof AfaGrid>) => {
  return <AfaGrid {...props} />;
};

export default Grid;
